import { RolePermission } from "admin/types/interfaces/grant";
import Role from "admin/types/interfaces/role";

const manifoldInternalIdentifier = "Manifold Internal";
type SortableRole = Role | { id: string; name: string };
type SortableFunctionalRole = { id: string; name: string; is_internal?: boolean };

// separates external and internal (name contains "Manifold Internal") roles, sorts each
// group alphabetically, then appends the two lists with external before internal. This
// will help visually display the customer-facing roles before the manifold internal roles
const sortRoles = (a: SortableRole, b: SortableRole) => {
  const isInternalA = a.name.includes(manifoldInternalIdentifier);
  const isInternalB = b.name.includes(manifoldInternalIdentifier);

  if (isInternalA && !isInternalB) {
    return 1;
  }
  if (!isInternalA && isInternalB) {
    return -1;
  }

  return a.name.localeCompare(b.name);
};

export default sortRoles;

export const sortFunctionalRoles = (a: SortableFunctionalRole, b: SortableFunctionalRole) => {
  const isInternalA = a.is_internal;
  const isInternalB = b.is_internal;

  if (isInternalA && !isInternalB) {
    return 1;
  }
  if (!isInternalA && isInternalB) {
    return -1;
  }

  return a.name.localeCompare(b.name);
};

// A role is assignable when the caller holds can_assign on it. A null/absent
// actions_permitted means FGA enforcement is off (or the caller is a system
// identity), in which case the caller falls back to the global admin check and
// every visible role is assignable.
export const canAssignRole = (role: Role) =>
  role.actions_permitted == null || role.actions_permitted.includes(RolePermission.can_assign);
